// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ResourceTier,
  DeploymentInstanceStatus,
  PinMode,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  imageId: __t.u32().name("image_id"),
  serviceId: __t.u32().name("service_id"),
  containerAppName: __t.string().name("container_app_name"),
  get status() {
    return DeploymentInstanceStatus;
  },
  get resourceTier() {
    return ResourceTier.name("resource_tier");
  },
  minReplicas: __t.u8().name("min_replicas"),
  maxReplicas: __t.u8().name("max_replicas"),
  errorMessage: __t.option(__t.string()).name("error_message"),
  fqdn: __t.option(__t.string()),
  requestedBy: __t.identity().name("requested_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  deployedAt: __t.option(__t.timestamp()).name("deployed_at"),
  imagePushedAt: __t.option(__t.timestamp()).name("image_pushed_at"),
  autoDeploy: __t.bool().name("auto_deploy"),
  get pinMode() {
    return PinMode.name("pin_mode");
  },
  pinnedRef: __t.option(__t.string()).name("pinned_ref"),
  rescueAttempts: __t.u32().name("rescue_attempts"),
});
